export class MenuItems {
  items: MenuItem[] = [
    // {
    //   title: 'home',
    //   url: '/home',
    //   icon: 'home'
    // },
    {
      title: 'dashboard',
      url: '/dashboard',
      icon: 'dashboard',
      permissionsKey: 'read-dashboard'
    },
    {
      title: 'jaddah-map',
      url: '/jaddah-map',
      icon: 'dashboard',
      permissionsKey: 'read-dashboard'
    },
    {
      title: 'users',
      url: '/users',
      icon: 'people',
      permissionsKey: 'read-user'
    },
    {
      title: 'roles',
      url: '/roles',
      icon: 'people',
      permissionsKey: 'read-role'
    },
    {
      title: 'unit-type',
      url: '/unit-type',
      icon: 'unit-type',
      permissionsKey: 'read-unit-type'
    },
    {
      title: 'contractors',
      url: '/contractors',
      icon: 'home',
      permissionsKey: 'read-contractor'
    },
    {
      title: 'waste-types',
      url: '/waste-types',
      icon: 'waste-type',
      permissionsKey: 'read-waste-type'
    },

    {
      title: 'districts',
      url: '/districts',
      icon: 'home',
      permissionsKey: 'read-district'
    },
    {
      title: 'contracts',
      url: '/contracts',
      icon: 'home',
      permissionsKey: 'read-contract'
    },
    {
      title: 'units',
      url: '/units',
      icon: 'home',
      permissionsKey: 'read-unit'
    },

    // {
    //   title: 'gates',
    //   url: '/gates',
    //   icon: 'gates',
    //   permissionsKey: 'read-gate'
    // },
    {
      title: 'scales',
      url: '/scales',
      icon: 'scales',
      permissionsKey: 'read-scale'
    },
    {
      title: 'devices',
      url: '/devices',
      icon: 'devices',
      permissionsKey: 'read-device'
    },
    {
      title: 'zones',
      url: '/zones',
      icon: 'zones',
      permissionsKey: 'read-zone'
    },
    {
      title: 'transitional-station',
      url: '/transitional-station',
      icon: 'transitional-station',
      permissionsKey: 'read-transitional-station'
    },
    {
      title: 'permissions',
      url: '/permissions',
      icon: 'permissions',
      permissionsKey: 'read-permission'
    },
    {
      title: 'entrance_permission',
      url: '/entrance_permission',
      icon: 'permissions',
      permissionsKey: 'read-entrance'
    },
    // {
    //   title: 'activity-log',
    //   url: '/activity-log',
    //   icon: 'activity-log',
    //   permissionsKey: 'read-dashboard'
    // },
    {
      title: 'geofences',
      url: '/geofences',
      icon: 'geofences',
      permissionsKey: 'read-geofence'
    },
    {
      title: 'inspector',
      url: '',
      icon: 'inspector',
      permissionsKey: 'read-inspector',
      children: [
        {
          title: 'violation',
          url: '/inspector/violations-current',
          exact: true,
          icon: ''
        }
      ]
    },
    {
      title: 'reports',
      url: '/report/contractor',
      icon: 'people',
      permissionsKey: 'read-dashboard',
      children: [
        {
          title: 'contractors_units',
          url: '/reports/units',
          exact: true,
          icon: ''
        },
        {
          title: 'waste_types',
          url: '/reports/waste-types',
          exact: true,
          icon: ''
        },
        {
          title: 'contractors',
          url: '/reports/contractors',
          exact: true,
          icon: ''
        },
        {
          title: 'districts',
          url: '/reports/districts',
          exact: true,
          icon: ''
        },
        {
          title: 'per-hour',
          url: '/reports/per-hour',
          exact: true,
          icon: ''
        },
        {
          title: 'violations',
          url: '/reports/violations',
          exact: true,
          icon: ''
        },
        {
          title: 'stations',
          url: '/reports/stations',
          exact: true,
          icon: ''
        },
        {
          title: 'tires-factory',
          url: '/reports/tires-factory',
          exact: true,
          icon: ''
        },
        {
          title: 'leaching-station',
          url: '/reports/leaching-station',
          exact: true,
          icon: ''
        },
        {
          title: 'cells',
          url: '/reports/cells',
          exact: true,
          icon: ''
        },
        {
          title: 'sorting-area',
          url: '/reports/sorting-area',
          exact: true,
          icon: ''
        },
        {
          title: 'washing',
          url: '/reports/washing',
          exact: true,
          icon: ''
        },
        {
          title: 'incinerator',
          url: '/reports/incinerator',
          exact: true,
          icon: ''
        }
      ]
    }
    // {
    //   title: 'reports',
    //   url: '/report/contractor',
    //   icon: 'people',
    //   permissionsKey: 'read-dashboard',
    //   children: [
    //     {
    //       title: 'contractors_units',
    //       url: '/report/contractors_units',
    //       exact: true,
    //       icon: ''
    //     },
    //     {
    //       title: 'waste_types',
    //       url: '/report/waste_types',
    //       exact: true,
    //       icon: ''
    //     },
    //     {
    //       title: 'contractors',
    //       url: '/report/contractors',
    //       exact: true,
    //       icon: ''
    //     },
    //     {
    //       title: 'districts',
    //       url: '/report/districts',
    //       exact: true,
    //       icon: ''
    //     },
    //     {
    //       title: 'transitional-station',
    //       url: '/report/transitional_stations',
    //       exact: true,
    //       icon: ''
    //     },
    //     {
    //       title: 'violations',
    //       url: '/report/violations',
    //       exact: true,
    //       icon: ''
    //     },
    //     {
    //       title: 'permissions',
    //       url: '/report/permissions',
    //       exact: true,
    //       icon: ''
    //     }
    //   ]
    // }
  ];
}

interface MenuItem {
  title: string;
  url?: string;
  icon: string;
  active?: boolean;
  permissionsKey?: string;
  mdiIcon?: boolean;
  children?: {
    title: string;
    url: string;
    icon?: string;
    hidden?: boolean;
    exact?: boolean;
  }[];
}
